import React, { useCallback, useEffect, useState } from 'react';
import { NavPage } from '../../../services/NavService';
import { CacheClient, ISyncStatus, SyncClient, VersionClient } from '../../../services/WebApiClient';
import { useClient } from '../../../util/useClient';
import { usePromise } from '../../EditorCommon/usePromise';
import { LoadSpinner } from '../../LoadSpinner';
import { Table } from '../../Table/Table';
import { AdminNav } from '../AdminNav/AdminNav';


export function MiscAdmin(props: {

}) {

    const syncClient = useClient(SyncClient);
    const cacheClient = useClient(CacheClient);
    const [syncState, setSyncState] = useState<ISyncStatus | undefined>();


    const fetchSyncState = useCallback(async () => {
        const s = await syncClient.getStatus();
        setSyncState(s);
    }, [syncClient])

    useEffect(() => {
        fetchSyncState();
        const timerHandle = setInterval(() => fetchSyncState(), 5000);

        function effectCleanup() {
            clearInterval(timerHandle);
        }
        return effectCleanup;
    }, [fetchSyncState]);

    const versionClient = useClient(VersionClient);
    const serverVersion = usePromise(useCallback(async () => {
        return await versionClient.getVersion();
    }, [versionClient]))


    async function sync() {
        await syncClient.startSync();
        await fetchSyncState();
    }

    async function stopSync() {
        await syncClient.stopSync();
    }

    async function clearCache() {
        await cacheClient.clearCache();
    }

    const versions = [
        {
            name: "client",
            version: process.env.REACT_APP_VERSION,
            buildName: process.env.REACT_APP_BUILDNAME,
            commitHash: process.env.REACT_APP_COMMITHASH
        },
        {
            name: "server",
            version: serverVersion?.versionNumber,
            buildName: serverVersion?.versionName,
            commitHash: serverVersion?.commitHash
        }
    ];



    return (
        <div className="misc-admin editor">
            <AdminNav page={NavPage.Admin.Misc} />


            <div className="main-editor">

                <div className="btn-group">
                    <button className="btn btn-warning"
                        onClick={sync}
                    >
                        Synchronize products and prices
                    </button>
                    <button className="btn btn-warning"
                        onClick={stopSync}
                    >
                        Stop Synchronization
                    </button>

                </div>

                <ul className="list-group">
                    <li className="list-group-item">
                        Synchronization started: {syncState?.started?.toLocaleString() ?? "Unknown"}
                    </li>
                    <li className="list-group-item">
                        Synchronization completed: {syncState?.started
                            ? (syncState?.completed?.toLocaleString() ?? <LoadSpinner />)
                            : ("")}
                    </li>
                </ul>
                <br />
                <br />

                <button className="btn btn-warning"
                    onClick={clearCache}
                >
                    Clear cache
                </button>
                <br />
                <br />

                <Table rows={versions}
                    columns={[
                        {
                            content: v => v.name,
                            key: "name",
                            header: "Name"
                        },
                        {
                            content: v => v.version,
                            key: "Version",
                            header: "Version"
                        },
                        {
                            content: v => v.buildName,
                            key: "VersionName",
                            header: "Version Name"
                        },
                        {
                            content: v => <span title={v.commitHash}>{v.commitHash?.substring(0, 10)}</span>,
                            key: "commitHash",
                            header: "Commit Hash"
                        }
                    ]}
                />
            </div>
        </div>
    );
}
